// @ts-nocheck
/* eslint-disable */
export const appClose24Icon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="close-24_svg__Layer_1" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve"><path xmlns="http://www.w3.org/2000/svg" d="M18.7,5.5L5.3,18.9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path xmlns="http://www.w3.org/2000/svg" d="M18.7,18.5L5.3,5.1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'close-24' as const
};